module.exports = __webpack_public_path__ + "img/turbo-features9.74891367.png";